import React, { FC } from 'react';
import { PermissionsCheckProps } from './PermissionCheck';
import { useHasGlobalPermissions } from '../../auth/auth-helper';

export const GlobalPermissionsCheck: FC<PermissionsCheckProps> = (props) => {
  const { hasPermission } = useHasGlobalPermissions();
  const accessIsAllowed = hasPermission(props.permissions);

  if (props.children instanceof Function) {
    return <>{props.children(accessIsAllowed)}</>;
  }

  return accessIsAllowed ? <>{props.children}</> : <></>;
};
